// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"3ab94d4c","709":"100bcf96","731":"74c5f114","905":"be38bb10","977":"b46689e6"}[chunkId] + ".chunk.js";
};